import { OpenedEvent } from 'onesignal-cordova-plugin/dist/models/NotificationOpened';
import NotificationReceivedEvent from 'onesignal-cordova-plugin/dist/NotificationReceivedEvent';

/** OneSignal Configuration */
export interface OneSignalConfig {
  appId: string;
  // subdomainName: string;
  safari_web_id: string;
  notifyButton: {
    enable: boolean;
  };
  allowLocalhostAsSecureOrigin: boolean;
}

/** OneSignal Common interface */
export interface OneSignalSDK {
  setLogger(logger: any);
  init: (config: OneSignalConfig) => Promise<void>;
  isPushNotificationsEnabled: () => Promise<boolean>;
  setSubscription(
    newSubscription: boolean,
    externalUserId: string
  ): Promise<void>;
  getNotificationPermission(
    onComplete?: Function
  ): Promise<NotificationPermission>;
  showPrompt(): Promise<void>;
  setNotificationOpenedHandler(handler: (event: OpenedEvent) => void): void;
  setNotificationWillShowInForegroundHandler(
    handler: (event: NotificationReceivedEvent) => void
  ): void;
}

const PORTAL_URL = `${process.env.REACT_APP_DEEP_LINK_SCHEME}://${process.env.REACT_APP_DEEP_LINK_HOST}`;

export const notifHelper = {
  toInternalLink: (link: string) => {
    if (
      link.startsWith(PORTAL_URL) ||
      link.startsWith(window.location.origin)
    ) {
      const url = new URL(link);
      return url.pathname;
    } else {
      return null;
    }
  },
};
